var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path0, _path1, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgEnapterEnergyStorage72(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 72,
    height: 72,
    viewBox: "0 0 72 72",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M22.4196 38.2049L6.91797 29.3633",
    stroke: "#BDBDBD",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M35.2724 37.5296L36.1909 37.0004L34.0716 41.0372L34.4096 39.8384L34.7435 38.6543L33.6782 39.2698L32.8056 39.774L34.0438 35.4485L35.4938 34.6132L34.5597 36.9078L34.0106 38.2565L35.2724 37.5296Z",
    fill: "#BDBDBD",
    stroke: "#BDBDBD"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M22.4219 56.0938V69.2914",
    stroke: "#BDBDBD",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M35.2724 53.1005L36.1909 52.5713L34.0716 56.6081L34.4096 55.4093L34.7435 54.2252L33.6782 54.8407L32.8061 55.3446L34.0437 51.0267L35.4924 50.1921L34.5598 52.4784L34.0092 53.8282L35.2724 53.1005Z",
    fill: "#BDBDBD",
    stroke: "#BDBDBD"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M44.8844 25.3377L29.3828 16.4961",
    stroke: "#BDBDBD",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M44.8836 28.3242V40.917L22.4196 53.7762L6.91797 44.9346",
    stroke: "#BDBDBD",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M67.3499 12.4766L22.4219 38.2022V53.7182",
    stroke: "#BDBDBD",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M57.7265 24.67L58.6512 24.136L56.5344 28.171L56.8705 26.9791L57.2045 25.7949L56.1392 26.4104L55.2665 26.9146L56.5048 22.5889L57.9466 21.7562L57.0134 24.0484L56.4635 25.3992L57.7265 24.67Z",
    fill: "#BDBDBD",
    stroke: "#BDBDBD"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M44.8867 43.8281V56.4353",
    stroke: "#BDBDBD",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path0 || (_path0 = /*#__PURE__*/React.createElement("path", {
    d: "M67.3496 28.0586L47.3984 39.4778",
    stroke: "#BDBDBD",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path1 || (_path1 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M67.3491 43.5746L22.4211 69.293L4.32031 58.9682V27.8786L49.2483 2.16016L67.3491 12.4778V43.5746Z",
    stroke: "#BDBDBD",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M57.7265 40.2409L58.6512 39.707L56.5344 43.742L56.8705 42.55L57.2045 41.3658L56.1392 41.9813L55.2665 42.4855L56.5046 38.1603L57.9469 37.331L57.0135 39.619L56.4621 40.971L57.7265 40.2409Z",
    fill: "#BDBDBD",
    stroke: "#BDBDBD"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M21.6562 28.5278C21.6775 28.3159 21.7556 28.1137 21.8823 27.9426C22.0091 27.7715 22.1797 27.6378 22.3763 27.5558C22.8977 27.2931 23.4735 27.1563 24.0575 27.1563C24.6414 27.1562 25.2172 27.2931 25.7387 27.5558C25.9437 27.6227 26.1224 27.7527 26.2491 27.9273C26.3758 28.1019 26.444 28.3121 26.444 28.5278C26.444 28.7435 26.3758 28.9537 26.2491 29.1283C26.1224 29.3029 25.9437 29.4329 25.7387 29.4998C25.0557 29.8501 24.2805 29.9784 23.5211 29.867",
    stroke: "#BDBDBD",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M21.6562 28.5273V31.9401C21.678 32.151 21.7564 32.352 21.8831 32.5219C22.0099 32.6918 22.1803 32.8241 22.3763 32.9049C22.8967 33.171 23.4729 33.3097 24.0575 33.3097C24.642 33.3097 25.2182 33.171 25.7387 32.9049C25.9337 32.8228 26.1033 32.6901 26.2299 32.5205C26.3565 32.3509 26.4355 32.1505 26.4587 31.9401V28.5273",
    stroke: "#BDBDBD",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M31.0664 23.1333C31.0876 22.9214 31.1657 22.7192 31.2925 22.5481C31.4192 22.377 31.5899 22.2433 31.7864 22.1613C32.3079 21.8986 32.8837 21.7617 33.4676 21.7617C34.0515 21.7617 34.6273 21.8986 35.1488 22.1613C35.3504 22.2317 35.5252 22.3631 35.6488 22.5372C35.7724 22.7114 35.8389 22.9197 35.8389 23.1333C35.8389 23.3468 35.7724 23.5551 35.6488 23.7293C35.5252 23.9034 35.3504 24.0348 35.1488 24.1053C34.4845 24.4496 33.7309 24.5827 32.9888 24.4869",
    stroke: "#BDBDBD",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M31.0664 23.1328V26.5456C31.0891 26.757 31.1678 26.9586 31.2944 27.1294C31.4209 27.3003 31.5908 27.4343 31.7864 27.5176C32.3092 27.7804 32.8861 27.9173 33.4712 27.9173C34.0563 27.9173 34.6333 27.7804 35.156 27.5176C35.3516 27.4343 35.5215 27.3003 35.648 27.1294C35.7746 26.9586 35.8533 26.757 35.876 26.5456V23.1328",
    stroke: "#BDBDBD",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M44.1211 15.6959C44.1423 15.484 44.2204 15.2818 44.3472 15.1107C44.4739 14.9395 44.6446 14.8059 44.8411 14.7239C45.3638 14.4611 45.9408 14.3242 46.5259 14.3242C47.111 14.3242 47.6879 14.4611 48.2107 14.7239C48.4072 14.8059 48.5779 14.9395 48.7046 15.1107C48.8314 15.2818 48.9095 15.484 48.9307 15.6959C48.9102 15.908 48.8324 16.1105 48.7056 16.2818C48.5787 16.453 48.4076 16.5865 48.2107 16.6679C47.5463 17.0117 46.7914 17.1401 46.0507 17.0351",
    stroke: "#BDBDBD",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M44.1211 15.6953V19.1009C44.1423 19.3128 44.2204 19.515 44.3472 19.6861C44.4739 19.8572 44.6446 19.9909 44.8411 20.0729C45.3616 20.339 45.9378 20.4777 46.5223 20.4777C47.1068 20.4777 47.683 20.339 48.2035 20.0729C48.4004 19.9915 48.5715 19.8581 48.6984 19.6868C48.8252 19.5156 48.903 19.313 48.9235 19.1009V15.6953",
    stroke: "#BDBDBD",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "M53.5234 10.2739C53.5454 10.0622 53.6238 9.86038 53.7505 9.68939C53.8771 9.51841 54.0474 9.38458 54.2434 9.30189C54.7649 9.03919 55.3407 8.90234 55.9246 8.90234C56.5086 8.90234 57.0844 9.03919 57.6058 9.30189C57.8028 9.38327 57.9739 9.51675 58.1007 9.68799C58.2276 9.85923 58.3054 10.0618 58.3258 10.2739C58.3054 10.486 58.2276 10.6886 58.1007 10.8598C57.9739 11.031 57.8028 11.1645 57.6058 11.2459C56.9598 11.5829 56.2267 11.716 55.5034 11.6275",
    stroke: "#BDBDBD",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    d: "M53.5234 10.2734V13.679C53.5454 13.8907 53.6238 14.0926 53.7505 14.2635C53.8771 14.4345 54.0474 14.5683 54.2434 14.651C54.7639 14.9171 55.3401 15.0558 55.9246 15.0558C56.5092 15.0558 57.0854 14.9171 57.6058 14.651C57.8028 14.5697 57.9739 14.4362 58.1007 14.2649C58.2276 14.0937 58.3054 13.8912 58.3258 13.679V10.2734",
    stroke: "#BDBDBD",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEnapterEnergyStorage72);
export default __webpack_public_path__ + "static/media/enapter-energy-storage-72.4df7371401bf287267a7dcb090ee37cc.svg";
export { ForwardRef as ReactComponent };